import useProjectQuery, { Program, Project } from "@/api/query/useProjectQuery";
import {
  OverAllTrackEnumValue,
  ProjectDefaultViewEnumValue,
  ProjectStatusEnumValue,
  ScheduleAndBudgetTrend,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import {
  createPortfolioAndProgramSchema,
  updateProjectSchema,
} from "@backend/src/schemas/projectSchema";
import { useFormik } from "formik";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import Select, { SingleValue, components } from "react-select";
import { toast } from "react-toastify";
import { toFormikValidationSchema } from "zod-formik-adapter";
import useProjectUpdateMutation from "@/api/mutation/useProjectUpdateMutation";
import { isAxiosError } from "axios";
import { z } from "zod";
import kanaban from "../../assets/svg/kanBanNew.svg";
import gantt from "../../assets/svg/ganttNew.svg";
import calendar from "../../assets/svg/CalenderNewIcon.svg";
import list from "../../assets/svg/listNew.svg";
import countries from "../../assets/json/countries.json";
import { InputRadio } from "../common/InputRadio";
import InputText from "../common/InputText";
import ErrorMessage from "../common/ErrorMessage";
import Cloudy from "../../assets/svg/cloudy.svg";
import Stormy from "../../assets/svg/stormy.svg";
import Sunny from "../../assets/svg/sunny.svg";
import Rainy from "../../assets/svg/Rainy.svg";
import InfoCircle from "../../assets/svg/Info circle.svg";
import dateFormater from "@/helperFuntions/dateFormater";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import { errorConfig } from "@/lib/toastError";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import useAllPortfoliosQuery, {
  Portfolios,
} from "@/api/query/useAllPortFoliosQuery";
import Dialog from "../common/Dialog";
import CrossIcon from "../../assets/svg/CrossIcon.svg";
import { Button } from "../ui/button";
import useCreatePortfolioProgramMutation from "@/api/mutation/useCreatePortfolioProgram";
import NewPlus from "@/assets/svg/NewPlus.svg";
import useRemoveProgramMutation from "@/api/mutation/useRemoveProgramMutaiton";
import useRemovePortfolioMutation from "@/api/mutation/useRemovePortfolioMutaiton";
import TrashCan from "@/assets/svg/TrashCan.svg";
import { useUser } from "@/hooks/useUser";
import InputNumber from "../common/InputNumber";
import { useBlocker } from "react-router-dom";
import { pick } from "lodash";
import { LucideAlertTriangle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Calendar } from "../ui/calendar";
import CalendarIcon from "../../assets/svg/newCalendarIcon.svg";
import { OrgListOfNonWorkingDaysEnum } from "@backend/src/schemas/organisationSchema";

type Options = { label: string | JSX.Element; value: string };

type AddProjectType = {
  editData?: Project;
  refetch: () => void;
  viewOnly: boolean;
  cancel?: () => void;
};

export type SubmitRef = {
  callSubmit: () => void;
};
const reactSelectStyleWorkingDays = {
  control: (
    provided: Record<string, unknown>,
    state: { isFocused: boolean }
  ) => ({
    ...provided,
    border: "1px solid #E7E7E7",
    paddingTop: "0.2rem",
    paddingBottom: "0.2rem",
    paddingLeft: "0.2rem",
    outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
    boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
    "&:hover": {
      outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
      boxShadow: "0px 0px 0px #299d91",
    },
  }),
  option: (
    provided: Record<string, unknown>,
    state: { isSelected: boolean }
  ) => ({
    ...provided,
    color: state.isSelected ? "white" : "black",
    background: state.isSelected ? "#299d91" : "white",
    "&:hover": {
      color: "white",
      background: "#299d9199",
    },
  }),
} as const;
const reactSelectStyle = {
  control: (
    provided: Record<string, unknown>,
    state: { isFocused: boolean }
  ) => ({
    ...provided,
    border: "1px solid #E7E7E7",
    paddingTop: "0.2rem",
    paddingBottom: "0.2rem",
    paddingLeft: "0.2rem",
    outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
    boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
    "&:hover": {
      outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
      boxShadow: "0px 0px 0px #299d91",
    },
  }),
  option: (
    provided: Record<string, unknown>,
    state: { isSelected: boolean }
  ) => ({
    ...provided,
    color: state.isSelected ? "white" : "black",
    background: state.isSelected ? "#299d91" : "white",
    "&:hover": {
      color: "white",
      background: "#299d9199",
    },
  }),
} as const;
export const CreateProjectNoPopUpForm = forwardRef<SubmitRef, AddProjectType>(
  (props, ref) => {
    useImperativeHandle(ref, () => ({
      callSubmit() {
        formik.handleSubmit();
      },
    }));

    const blocker = useBlocker(
      ({ currentLocation, nextLocation }) =>
        chackIschange && currentLocation.pathname !== nextLocation.pathname
    );

    const { t } = useTranslation();
    const RADIO_BUTTON_OPTIONS = [
      {
        id: 4,
        title: t("list"),
        value:ProjectDefaultViewEnumValue.LIST,
        description: t("list_description"),
        img: list,
      },
      {
        id: 2,
        title: t("gantt"),
        value:ProjectDefaultViewEnumValue.GANTT,
        description: t("gantt_description"),
        img: gantt,
      },
      {
        id: 1,
        title: t("kanban"),
        value:ProjectDefaultViewEnumValue.KANBAN,
        description: t("kanban_description"),
        img: kanaban,
      },
      {
        id: 3,
        title: t("calendar"),
        value:ProjectDefaultViewEnumValue.CALENDAR,
        description: t("calendar_description"),
        img: calendar,
      },
    ];
    const { user } = useUser();
    const { editData, refetch, viewOnly } = props;
    const errorStyle = "text-red-400 block text-sm h-1";
    const labelStyle = "font-medium text-base text-gray-450/30";
    const inputStyle =
      "py-1.5 px-3 rounded-md border border-gray-100 mt-2 w-full h-[46px]";
    const projectUpdateMutation = useProjectUpdateMutation(
      editData ? editData.projectId : ""
    );
    const [currencyValue, setCurrencyValue] = useState<SingleValue<Options>>();
    const projectQuery = useProjectQuery();
    const formik = useFormik<z.infer<typeof updateProjectSchema>>({
      initialValues: {
        projectName: "",
        projectDescription: "",
        startDate: "" as unknown as Date,
        estimatedEndDate: "" as unknown as Date,
        estimatedBudget: "",
        defaultView: ProjectDefaultViewEnumValue.LIST,
        currency: "USD",
        status: ProjectStatusEnumValue.NOT_STARTED,
        overallTrack: OverAllTrackEnumValue.SUNNY,
        scheduleTrend: ScheduleAndBudgetTrend.STABLE,
        budgetTrend: ScheduleAndBudgetTrend.STABLE,
        consumedBudget: "",
        isMilestone: false,
      },
      validationSchema: toFormikValidationSchema(updateProjectSchema),
      onSubmit: (values, helper) => {
        if (editData && editData.projectId) {
          projectUpdateMutation.mutate(values, {
            onSuccess(data) {
              projectQuery.refetch();
              refetch();
              toast.success(data.data.message);
              if (props.cancel) {
                props.cancel();
              }
            },
            onError(error) {
              if (isAxiosError(error)) {
                if (
                  error.response?.status === 400 &&
                  error.response.data?.errors &&
                  Array.isArray(error.response?.data.errors)
                ) {
                  error.response.data.errors.forEach((item) => {
                    helper.setFieldError(item.path[0], item.message);
                  });
                }
                if (!Array.isArray(error.response?.data.errors)) {
                  toast.error(
                    errorKeyFormate(error.response?.data.message + ""),
                    errorConfig
                  );
                }
              }
            },
          });
        }
      },
    });

    // Custom equality function
    function isValidDate(input: string | Date) {
      const date = new Date(input);
      return !isNaN(date.getTime());
    }

    function isFalsyEquivalent(val: any): boolean {
      return val === undefined || val === null || val === "";
    }

    function customIsEqual(obj1: any, obj2: any): boolean {
      if (isFalsyEquivalent(obj1) && isFalsyEquivalent(obj2)) return true;
      if (typeof obj1 === "boolean" || typeof obj2 === "boolean") {
        return Boolean(obj1) === Boolean(obj2);
      }

      if (isValidDate(obj1) && isValidDate(obj2)) {
        return (
          new Date(obj1).toLocaleDateString() ===
          new Date(obj2).toLocaleDateString()
        );
      }

      // One is falsy but not equivalent
      if (isFalsyEquivalent(obj1) || isFalsyEquivalent(obj2)) return false;

      // Boolean comparison with possible undefined

      // Type mismatch
      if (typeof obj1 !== typeof obj2) return false;

      // Trim and compare strings
      if (typeof obj1 === "string" && typeof obj2 === "string") {
        return obj1.trim() === obj2.trim();
      }

      // Direct comparison
      return obj1 === obj2;
    }

    const chackIschange = useMemo(() => {
      const compareFields: (keyof Project)[] = Object.keys(
        formik.values
      ) as unknown as (keyof Project)[];

      const filteredEditData = pick(editData, compareFields);
      const filteredFormikValues = pick(
        formik.values as unknown as Project,
        compareFields
      );

      // Compare values using the custom equality function
      const isChanged = compareFields.filter((key) => {
        if (key == "program") {
          return !customIsEqual(
            filteredEditData[key]?.programId,
            filteredFormikValues[key]
          );
        }
        if (key == "portfolio") {
          return !customIsEqual(
            filteredEditData[key]?.portfolioId,
            filteredFormikValues[key]
          );
        }
        return !customIsEqual(filteredEditData[key], filteredFormikValues[key]);
      });

      return Boolean(!(isChanged.length - 1));
    }, [formik.values, editData]); // Dependenci
    useEffect(() => {
      const handleBeforeUnload = (e: {
        preventDefault: () => void;
        returnValue: string;
      }) => {
        if (chackIschange) {
          e.preventDefault();
          e.returnValue = ""; // Chrome requires returnValue to be set
        }
      };

      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }, [chackIschange]);

    const createPortfolioAndProgramFormik = useFormik({
      initialValues: { program: "", portfolio: "" },
      validationSchema: toFormikValidationSchema(
        createPortfolioAndProgramSchema
      ),
      onSubmit(values) {
        createPortfolioAndProgram(values);
      },
    });
    const createPortfolioProgramMutation = useCreatePortfolioProgramMutation();
    const createPortfolioAndProgram = (
      value: z.infer<typeof createPortfolioAndProgramSchema>
    ) => {
      createPortfolioProgramMutation.mutate(value, {
        onSuccess() {
          allPortfoliosQuery.refetch().then((res) => {
            const findPortfolio = res.data?.data.data.portfolios.find(
              (p) => p.portfolioName == value.portfolio
            );
            const findNewProgram = findPortfolio?.programs.find(
              (t) => t.programName == value.program
            );
            formik.setValues({
              program: findNewProgram?.programId,
              portfolio: findPortfolio?.portfolioId,
            });
          });
          setCreatePortfolio(undefined);
          createPortfolioAndProgramFormik.resetForm();
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message ?? ""),
            errorConfig
          );
        },
      });
    };
    const HandleOverallTrack = (track: string) => {
      switch (track) {
        case OverAllTrackEnumValue.STORMY:
          return <img src={Stormy} className="h-8 w-8" />;
        case OverAllTrackEnumValue.CLOUDY:
          return <img src={Cloudy} className="h-8 w-8" />;
        case OverAllTrackEnumValue.SUNNY:
          return <img src={Sunny} className="h-8 w-8" />;
        case OverAllTrackEnumValue.RAINY:
          return <img src={Rainy} className="h-8 w-8" />;
      }
    };
    useEffect(() => {
      if (editData) {
        const formatDate = (inputDate: string) => {
          const date = new Date(inputDate);
          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const day = date.getDate();

          return `${year}-${month.toString().padStart(2, "0")}-${day
            .toString()
            .padStart(2, "0")}`;
        };
        formik.setValues({
          startDate: formatDate(editData.startDate) as unknown as Date,
          estimatedEndDate: editData.estimatedEndDate
            ? (formatDate(editData.estimatedEndDate) as unknown as Date)
            : undefined,
          estimatedBudget: editData.estimatedBudget ?? "",
          projectDescription: editData.projectDescription ?? "",
          projectName: editData.projectName,
          defaultView: editData.defaultView,
          currency: editData.currency,
          overallTrack: editData.overallTrack,
          scheduleTrend: editData.scheduleTrend,
          budgetTrend: editData.budgetTrend,
          consumedBudget: editData.consumedBudget ?? "  ",
          status: editData.status,
          portfolio: editData.portfolio?.portfolioId ?? "",
          program: editData.program?.programId ?? "",
          isMilestone: editData.isMilestone ?? false,
        });
        setCurrencyValue({
          label: editData.currency,
          value: editData.currency,
        });
      }
    }, [editData]);

    const currencyFn = () => {
      const value = countries.map((item) => {
        return { label: item.currency, value: item.currency };
      });

      const seenValues = new Set();
      const uniqueArray = value
        .filter((item) => {
          if (seenValues.has(item.value)) {
            return false;
          }
          seenValues.add(item.value);
          return true;
        })
        .sort((a, b) => {
          return a.value.localeCompare(b.value);
        });

      return uniqueArray;
    };

    const handleCurrency = (val: SingleValue<Options>) => {
      if (val) {
        setCurrencyValue(val);
        formik.setFieldValue("currency", val.value);
      }
    };
    const allPortfoliosQuery = useAllPortfoliosQuery();
    const [createPortfolio, setCreatePortfolio] = useState<
      "portfolio" | "program"
    >();
    const [allPortfolios, setAllPortfolios] = useState<{
      programs: Program[];
      portfolios: Portfolios[];
    }>();
    const [portfolios, setPortfolios] = useState<Options[]>([]);
    const [programs, setPrograms] = useState<Options[]>([]);
    const [deletePortfolioAndProgram, setDeletePortfolioAndProgram] = useState<{
      portfolio: string;
      program: string;
    }>();
    useEffect(() => {
      const data = allPortfoliosQuery.data?.data.data;
      setAllPortfolios(data);
      setPortfolios([
        { label: t("Select portfolio"), value: "" },
        ...(data?.portfolios ?? []).map(({ portfolioId, portfolioName }) => ({
          value: portfolioId,
          label: (
            <div className={`flex gap-2 justify-between items-center`}>
              {portfolioName}
              <span
                className={`font-bold text-xs text-red-400 ${
                  formik.values.portfolio == portfolioId ? "hidden" : ""
                }`}
                onClick={() => {
                  setDeletePortfolioAndProgram({
                    portfolio: portfolioId,
                    program: "",
                  });
                }}
              >
                ✖
              </span>
            </div>
          ),
        })),
      ]);
    }, [allPortfoliosQuery.data?.data.data, formik.values.portfolio]);

    useEffect(() => {
      const selectedPortfolio = allPortfolios?.portfolios.find(
        ({ portfolioId }) => portfolioId === formik.values.portfolio
      );
      if (selectedPortfolio && selectedPortfolio?.programs?.length) {
        setPrograms([
          { label: t("Select program"), value: "" },
          ...(selectedPortfolio?.programs?.map(
            ({ programId, programName }) => ({
              value: programId,
              label: (
                <div className="flex gap-2 justify-between items-center">
                  {programName}
                  <span
                    className={`font-bold text-xs text-red-400 ${
                      formik.values.program == programId ? "hidden" : ""
                    } `}
                    onClick={() => {
                      setDeletePortfolioAndProgram({
                        portfolio: "",
                        program: programId,
                      });
                    }}
                  >
                    ✖
                  </span>
                </div>
              ),
            })
          ) ?? []),
        ]);
      } else {
        setPrograms([
          { label: t("Select program"), value: "" },
          ...(allPortfolios?.programs?.map(({ programId, programName }) => ({
            value: programId,
            label: (
              <div className="flex gap-2 justify-between items-center">
                {programName}
                <span
                  className={`font-bold text-xs text-red-400 ${
                    formik.values.program == programId ? "hidden" : ""
                  } `}
                  onClick={() => {
                    setDeletePortfolioAndProgram({
                      portfolio: "",
                      program: programId,
                    });
                  }}
                >
                  ✖
                </span>
              </div>
            ),
          })) ?? []),
        ]);
      }
    }, [formik.values.portfolio, allPortfolios, formik.values.program, t]);
    const [programDefaultValue, setProgramDefaultValue] = useState<Options>();

    useEffect(() => {
      const programValue =
        allPortfolios?.portfolios
          .find((t) => t.portfolioId == formik.values.portfolio)
          ?.programs.find((p) => p.programId == formik.values.program) ??
        allPortfolios?.programs.find(
          (p) => p.programId == formik.values.program
        );
      if (programValue) {
        setProgramDefaultValue({
          label: programValue?.programName ?? "",
          value: programValue?.programId ?? "",
        });
      } else {
        setProgramDefaultValue({ label: t("Select program"), value: "" }); // Clear value if no match is found
      }
    }, [
      programs.length,
      formik.values.portfolio,
      formik.values.program,
      allPortfolios,
    ]);
    const removeProgramMutation = useRemoveProgramMutation();
    const removePortfolioMutation = useRemovePortfolioMutation();
    const handleRemovePortfolioAndProgram = () => {
      if (deletePortfolioAndProgram?.portfolio) {
        removePortfolioMutation.mutate(deletePortfolioAndProgram?.portfolio, {
          onSuccess() {
            allPortfoliosQuery.refetch().then(() => {
              formik.setFieldValue("portfolio", "");
              setDeletePortfolioAndProgram(undefined);
              projectQuery.refetch();
            });
          },
          onError(error) {
            toast.error(
              errorKeyFormate(error.response?.data.message ?? ""),
              errorConfig
            );
          },
        });
      }
      if (deletePortfolioAndProgram?.program) {
        removeProgramMutation.mutate(deletePortfolioAndProgram?.program, {
          onSuccess() {
            allPortfoliosQuery.refetch().then(() => {
              formik.setFieldValue("program", "");
              setDeletePortfolioAndProgram(undefined);
              projectQuery.refetch();
            });
          },
          onError(error) {
            toast.error(
              errorKeyFormate(error.response?.data.message ?? ""),
              errorConfig
            );
          },
        });
      }
    };

    const holiday = user?.userOrganisation[0].organisation.orgHolidays?.map(
      (t) => new Date(t.holidayStartDate)
    );
    const nonWorkingDays = () => {
      const nWd =
        user?.userOrganisation.map((org) => org.organisation.nonWorkingDays) ||
        [];
      const mapDayToNumber = (day: OrgListOfNonWorkingDaysEnum) => {
        switch (day) {
          case "SUN":
            return 0;
          case "MON":
            return 1;
          case "TUE":
            return 2;
          case "WED":
            return 3;
          case "THU":
            return 4;
          case "FRI":
            return 5;
          case "SAT":
            return 6;
          default:
            return 0;
        }
      };
      const result: number[] = [];
      nWd.forEach((days) => {
        days.forEach((day) => {
          result.push(mapDayToNumber(day));
        });
      });
      return result;
    };

    return (
      <div className="flex flex-col lg:flex-row w-full lg:justify-between gap-1">
        <div className="lg:w-2/3 p-0.5">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="text-left">
              <div className="flex justify-between items-center">
                <label className={`${labelStyle}`}>
                  {t("project_name")}
                  <span className="ml-0.5 text-red-500">*</span>
                </label>
                {/* <div className="flex gap-2 items-center">
                  <input
                    type="checkbox"
                    checked={formik.values.isMilestone}
                    onChange={(e) => {
                      formik.setFieldValue("isMilestone", e.target.checked);
                    }}
                    disabled={viewOnly}
                  />
                  <label className={`${labelStyle}`}>{t("milestone")}</label>
                </div> */}
              </div>

              <InputText
                disabled={viewOnly}
                name="projectName"
                className={inputStyle}
                value={formik.values.projectName}
                placeholder="Project Name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <span className={errorStyle}>
                {formik.touched.projectName && formik.errors.projectName}
              </span>
            </div>

            <div className="flex gap-2 items-center w-full my-2 ">
              <div className="w-full">
                <div className="flex gap-2 justify-between items-center">
                  <label className={labelStyle}>{t("Portfolio")}</label>
                  {user?.userOrganisation[0]?.role &&
                    user?.userOrganisation[0].role ==
                      UserRoleEnumValue.ADMINISTRATOR && (
                      <Button
                        className="p-0 h-fit"
                        type="button"
                        variant={"none"}
                        onClick={() => setCreatePortfolio("portfolio")}
                        disabled={viewOnly}
                      >
                        {!viewOnly && (
                          <img
                            src={NewPlus}
                            alt=""
                            className="min-w-4 w-4 invert"
                          />
                        )}
                      </Button>
                    )}
                </div>
                <Select
                  className="mt-2"
                  key={formik.values.portfolio}
                  isDisabled={
                    user?.userOrganisation[0].role &&
                    user?.userOrganisation[0].role ==
                      UserRoleEnumValue.ADMINISTRATOR
                      ? viewOnly
                      : true
                  }
                  placeholder="Select Portfolio"
                  options={portfolios}
                  styles={reactSelectStyle}
                  value={portfolios.find(
                    (t) => t.value == formik.values.portfolio
                  )}
                  onChange={(e) => {
                    const val = e as Options;
                    if (val && val.value) {
                      formik.setFieldValue("portfolio", val.value);
                      const label =
                        allPortfoliosQuery.data?.data.data.portfolios.find(
                          (t) => t.portfolioId == val.value
                        );
                      createPortfolioAndProgramFormik.setFieldValue(
                        "portfolio",
                        label?.portfolioName
                      );
                    } else {
                      formik.setFieldValue("portfolio", "");
                      formik.setFieldValue("program", "");
                    }
                    formik.setFieldValue("program", "");
                  }}
                ></Select>
              </div>
              <div className="w-full">
                <div className="flex gap-2 justify-between items-center">
                  <label className={labelStyle}>{t("Program")}</label>
                  {user?.userOrganisation[0]?.role &&
                    user?.userOrganisation[0].role ==
                      UserRoleEnumValue.ADMINISTRATOR && (
                      <Button
                        className="p-0 h-fit"
                        type="button"
                        variant={"none"}
                        onClick={() => {
                          setCreatePortfolio("program");
                          const label =
                            allPortfoliosQuery.data?.data.data.portfolios.find(
                              (t) => t.portfolioId == formik.values.portfolio
                            );
                          createPortfolioAndProgramFormik.setFieldValue(
                            "portfolio",
                            label?.portfolioName
                          );
                        }}
                        disabled={viewOnly}
                      >
                        {!viewOnly && (
                          <img
                            src={NewPlus}
                            alt=""
                            className="min-w-4 w-4 invert"
                          />
                        )}
                      </Button>
                    )}
                </div>
                <Select
                  key={formik.values.program}
                  isDisabled={
                    user?.userOrganisation[0]?.role &&
                    user?.userOrganisation[0].role ==
                      UserRoleEnumValue.ADMINISTRATOR
                      ? viewOnly
                      : true
                  }
                  className="mt-2"
                  placeholder="Select Program"
                  options={programs}
                  styles={reactSelectStyle}
                  value={programDefaultValue}
                  onChange={(e) => {
                    const val = e as Options;
                    if (val && val.value) {
                      formik.setFieldValue("program", val.value);
                    } else {
                      formik.setFieldValue("program", "");
                    }
                  }}
                ></Select>
              </div>
            </div>
            <div className="text-left">
              <label className={`${labelStyle}`}>{t("Description")}</label>
              <textarea
                name="projectDescription"
                disabled={viewOnly}
                rows={5}
                cols={30}
                placeholder="Description"
                className="py-1.5 px-3 rounded-md border focus:outline-primary-400 border-gray-100 mt-2 w-full"
                value={formik.values.projectDescription}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <div
                className={`${errorStyle} ${
                  formik.errors.projectDescription ? "mb-3" : ""
                }`}
              >
                {formik.touched.projectDescription &&
                  t(formik.errors.projectDescription as string)}
              </div>
            </div>
            <div className="flex flex-col gap-10">
              <div className="sm:flex sm:gap-2.5 w-full flex  ">
                <div className="text-left w-full">
                  <label className={`${labelStyle}`}>
                    {t("estimated_start_date")}
                  </label>
                  <span className="ml-0.5 text-red-500">*</span>
                  {/* <input
                    type="date"
                    disabled={viewOnly}
                    name="startDate"
                    className={inputStyle}
                    value={formik.values.startDate as unknown as string}
                    placeholder="Start Date"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  /> */}
                  <Popover>
                    <PopoverTrigger className="w-full mt-2" disabled={viewOnly}>
                      <Button
                        variant={"none"}
                        disabled={viewOnly}
                        className="border px-4 py-2 rounded-md w-full !h-10"
                      >
                        <div className="flex w-full gap-3 justify-between">
                          <div className="">
                            {dateFormater(new Date(formik.values.startDate ??""))}
                          </div>
                          <img src={CalendarIcon} className="w-4 brightness-0" />
                        </div>
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent className="p-0 ">
                      <Calendar
                        mode="single"
                        fromYear={2020}
                        toYear={2300}
                        captionLayout="dropdown-buttons"
                        selected={new Date(formik.values.startDate??'')}
                        onSelect={(e) => {
                          formik.setFieldValue("startDate", e);
                        }}
                        defaultMonth={formik.values.startDate}
                        className="rounded-md border"
                        disabled={[
                          {
                            dayOfWeek: nonWorkingDays(),
                          },
                          ...(holiday ?? []),
                        ]}
                      />
                    </PopoverContent>
                  </Popover>
                  <span className={errorStyle}>
                    {formik.touched.startDate && formik.errors.startDate}
                  </span>
                </div>
                <div className="text-left w-full ">
                  <label className={`${labelStyle}`}>
                    {t("estimated_end_date")}
                  </label>
                  <span className="ml-0.5 text-red-500">*</span>
                  {/* <input
                    type="date"
                    disabled={viewOnly}
                    name="estimatedEndDate"
                    className={inputStyle}
                    value={formik.values.estimatedEndDate as unknown as string}
                    placeholder="End Date"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  /> */}
                       <Popover>
                    <PopoverTrigger className="w-full mt-2" disabled={viewOnly}>
                      <Button
                        variant={"none"}
                        disabled={viewOnly}
                        className="border px-4 py-2 rounded-md w-full !h-10"
                      >
                        <div className="flex w-full gap-3 justify-between">
                          <div className="">
                            {dateFormater(new Date(formik.values.estimatedEndDate ??""))}
                          </div>
                          <img src={CalendarIcon} className="w-4 brightness-0" />
                        </div>
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent className="p-0 ">
                      <Calendar
                        mode="single"
                        fromYear={2020}
                        toYear={2300}
                        captionLayout="dropdown-buttons"
                        selected={formik.values.estimatedEndDate}
                        onSelect={(e) => {
                          formik.setFieldValue("estimatedEndDate", e);
                        }}
                        defaultMonth={formik.values.estimatedEndDate ?? formik.values.startDate}
                        className="rounded-md border"
                        disabled={[
                          {
                            dayOfWeek: nonWorkingDays(),
                          },
                          {
                            before:new Date(formik.values.startDate??"")
                          },
                          ...(holiday ?? []),
                        ]}
                      />
                    </PopoverContent>
                  </Popover>
                  <span className={errorStyle}>
                    {formik.touched.estimatedEndDate && formik.errors.estimatedEndDate}
                  </span>
                </div>
              </div>
              <div className="flex-col gap-4 flex ">
                <div className="sm:flex sm:gap-2.5 w-full flex">
                  <div className="flex gap-0.5 text-sm w-1/2 lg:text-base text-gray-450">
                    {t("actual_start_date")}:
                    <div className="text-primary-500">
                      {editData?.actualEndDate
                        ? dateFormater(new Date(editData?.actualStartDate))
                        : `N/A`}
                    </div>
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger className="flex gap-1 mr-3 items-center ml-auto">
                          <img
                            src={InfoCircle}
                            className="h-[16px] w-[16px]"
                            alt="InfoCircle"
                          />
                        </TooltipTrigger>
                        <TooltipContent>
                          <p className="text-sm">
                            {t("actual_start_date_tooltip")}
                          </p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </div>
                  <div className="flex gap-0.5 text-sm w-1/2 lg:text-base text-gray-450">
                    {t("actual_end_date")}:
                    <div className="text-primary-500">
                      {editData?.actualEndDate
                        ? dateFormater(new Date(editData?.actualEndDate))
                        : `N/A`}
                    </div>
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger className="flex gap-1 mr-3 items-center ml-auto">
                          <img
                            src={InfoCircle}
                            className="h-[16px] w-[16px]"
                            alt="InfoCircle"
                          />
                        </TooltipTrigger>
                        <TooltipContent>
                          <p className="text-sm">{t("end_date_tooltip")}</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </div>
                </div>
                <div className="sm:flex sm:gap-2.5 w-full flex">
                  <hr className="w-full" />
                  <hr className="w-full" />
                </div>

                <div className="flex justify-between gap-3  w-full">
                  <div className="w-full">
                    <div className="flex gap-0.5 text-sm lg:text-base text-gray-450 w-full">
                      {t("estimated_duration")}:
                      <div className="text-primary-500">
                        {editData?.estimatedDuration ?? "N/A"}
                      </div>
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger className="flex gap-1 mr-3 items-center ml-auto">
                            <img
                              src={InfoCircle}
                              className="h-[16px] w-[16px]"
                              alt="InfoCircle"
                            />
                          </TooltipTrigger>
                          <TooltipContent>
                            <p className="text-sm">
                              {t("estimated_duration_tooltip")}
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    </div>
                    <hr className="w-full mt-4" />
                  </div>
                  <div className="w-full">
                    <div className="flex gap-0.5 w-full text-sm lg:text-base text-gray-450">
                      {t("actual_duration")}:
                      <div className="text-primary-500">
                        {editData?.actualDuration ?? "N/A"}
                      </div>
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger className="flex gap-1 mr-3 items-center ml-auto">
                            <img
                              src={InfoCircle}
                              className="h-[16px] w-[16px]"
                              alt="InfoCircle"
                            />
                          </TooltipTrigger>
                          <TooltipContent>
                            <p className="text-sm">
                              {t("actual_duration_tooltip")}
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    </div>
                    <hr className="w-full  mt-4" />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-1 lg:gap-0 w-full py-3">
              <div className="text-xs lg:text-base text-[#0D062D] w-[16ch]">
                {t("project_budget")}
              </div>
              <hr className="w-full" />
            </div>
            <div className="text-left flex flex-col lg:flex-row gap-2 w-full">
              <div className="currency lg:w-4/5">
                <label className={labelStyle}>{t("currency")}</label>
                <Select
                  isDisabled={viewOnly}
                  className="mt-2 focus:!outline-primary-500"
                  onChange={handleCurrency}
                  onBlur={() => formik.setTouched({ currency: true })}
                  options={currencyFn()}
                  defaultValue={{ label: "USD", value: "USD" }}
                  placeholder={t("currency")}
                  value={currencyValue}
                  name="currency"
                  menuPlacement="auto"
                  styles={reactSelectStyle}
                />
                <ErrorMessage>
                  {formik.touched.currency && formik.errors.currency}
                </ErrorMessage>
              </div>
              <div className="e_budget lg:w-2/5">
                <label className={labelStyle}> {t("estimated_budget")}</label>
                <InputNumber
                  disabled={viewOnly}
                  name="estimatedBudget"
                  placeholder={t("estimated_budget")}
                  className={inputStyle}
                  value={formik.values.estimatedBudget ?? ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <span className={errorStyle}>
                  {formik.touched.estimatedBudget &&
                    formik.errors.estimatedBudget}
                </span>
              </div>
              <div className="c_budget lg:w-2/5">
                <label className={labelStyle}>{t("consumed_budget")}</label>
                <InputNumber
                  disabled={viewOnly}
                  name="consumedBudget"
                  placeholder={t("consumed_budget")}
                  className={inputStyle}
                  value={formik.values.consumedBudget ?? ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <span className={errorStyle}>
                  {formik.touched.consumedBudget &&
                    formik.errors.consumedBudget}
                </span>
              </div>
            </div>
            <div className="flex items-center gap-1 lg:gap-0 w-full py-3">
              <div className="text-xs lg:text-base text-[#0D062D] w-[20ch]">
                {t("project_follow_up")}
              </div>
              <hr className="w-full" />
            </div>
            <div className="flex flex-col justify-between items-center gap-2 lg:flex-row w-full">
              <div className="w-full">
                <label className={labelStyle}>{t("status")}</label>
                <Select
                  isDisabled={viewOnly}
                  menuPlacement="auto"
                  value={
                    formik.values.status && {
                      label: t(formik.values.status),
                      value: formik.values.status,
                    }
                  }
                  name="status"
                  isMulti={false}
                  onChange={(e: SingleValue<Options>) =>
                    formik.setFieldValue("status", e?.value)
                  }
                  options={Object.keys(ProjectStatusEnumValue).map((i) => {
                    return { label: t(i), value: i };
                  })}
                  styles={reactSelectStyle}
                />
                <ErrorMessage>
                  {formik.touched.status && formik.errors.status}
                </ErrorMessage>
              </div>
              <div className="w-full">
                <label className={labelStyle}>{t("overall_track")}</label>
                <Select
                  isDisabled={viewOnly}
                  menuPlacement="auto"
                  value={
                    formik.values.overallTrack && {
                      label: t(formik.values.overallTrack),
                      value: formik.values.overallTrack,
                    }
                  }
                  components={{
                    Control: ({ children, ...rest }) => (
                      <components.Control {...rest}>
                        {HandleOverallTrack(formik.values.overallTrack ?? "")}{" "}
                        {children}
                      </components.Control>
                    ),
                  }}
                  name="overallTrack"
                  isMulti={false}
                  onChange={(e: SingleValue<Options>) =>
                    formik.setFieldValue("overallTrack", e?.value)
                  }
                  options={Object.keys(OverAllTrackEnumValue).map((i) => {
                    return {
                      label: (
                        <div className="flex gap-2">
                          {HandleOverallTrack(i)}
                          {t(i)}{" "}
                        </div>
                      ),
                      value: i,
                    } as unknown as Options;
                  })}
                  styles={reactSelectStyle}
                />
                <ErrorMessage>
                  {formik.touched.status && formik.errors.overallTrack}
                </ErrorMessage>
              </div>
            </div>
            <div className="flex flex-col justify-between items-center gap-2 lg:flex-row w-full">
              <div className="w-full">
                <label className={labelStyle}>{t("schedule_trend")}</label>
                <Select
                  isDisabled={viewOnly}
                  menuPlacement="auto"
                  value={
                    formik.values.scheduleTrend && {
                      label: t(formik.values.scheduleTrend),
                      value: formik.values.scheduleTrend,
                    }
                  }
                  name="scheduleTrend"
                  isMulti={false}
                  onChange={(e: SingleValue<Options>) =>
                    formik.setFieldValue("scheduleTrend", e?.value)
                  }
                  options={Object.keys(ScheduleAndBudgetTrend).map((i) => {
                    return { label: t(i), value: i };
                  })}
                  styles={reactSelectStyle}
                />
                <ErrorMessage>
                  {formik.touched.status && formik.errors.scheduleTrend}
                </ErrorMessage>
              </div>
              <div className="w-full">
                <label className={labelStyle}>{t("budget_trend")}</label>
                <Select
                  isDisabled={viewOnly}
                  menuPlacement="auto"
                  value={
                    formik.values.budgetTrend && {
                      label: t(formik.values.budgetTrend),
                      value: formik.values.budgetTrend,
                    }
                  }
                  name="budgetTrend"
                  isMulti={false}
                  onChange={(e: SingleValue<Options>) =>
                    formik.setFieldValue("budgetTrend", e?.value)
                  }
                  options={Object.keys(ScheduleAndBudgetTrend).map((i) => {
                    return { label: t(i), value: i };
                  })}
                  styles={reactSelectStyle}
                />
                <ErrorMessage>
                  {formik.touched.status && formik.errors.budgetTrend}
                </ErrorMessage>
              </div>
            </div>
          </form>
        </div>
        <div className="lg:w-1/3 p-0.5">
          <div className="text-xl font-normal text-gray-450">
            {t("default_view")}
          </div>
          <div className="flex flex-col gap-5 my-3 lg:my-1">
            {RADIO_BUTTON_OPTIONS &&
              RADIO_BUTTON_OPTIONS.map((radioButton) => (
                <div
                  key={radioButton.id}
                  className={`h-full w-full rounded-md ${
                    formik.values.defaultView ===
                      radioButton.value &&
                    !viewOnly &&
                    "border-primary-500 "
                  } `}
                >
                  <label>
                    <div
                      className={`border p-3 rounded-md flex gap-2 items-center ${
                        formik.values.defaultView ===
                          radioButton.value &&
                        !viewOnly &&
                        "bg-primary-500 text-white"
                      }  ${
                        viewOnly &&
                        formik.values.defaultView ===
                          radioButton.value &&
                        "bg-slate-100 border border-primary-500"
                      }`}
                    >
                      <InputRadio
                        disabled={viewOnly}
                        value={radioButton.value}
                        checked={
                          formik.values.defaultView ===
                          radioButton.value
                        }
                        onChange={formik.handleChange}
                        className="hidden"
                        name="defaultView"
                      />
                      <div
                        className={`h-[45px] w-[45px] flex shrink-0 ${
                          formik.values.defaultView ===
                          radioButton.value
                            ? "bg-primary-500 border border-slate-50"
                            : "bg-gray-400"
                        } p-2 rounded-md`}
                      >
                        <img
                          src={radioButton.img}
                          className="w-full h-full brightness-0 invert"
                          alt={`${radioButton.title}`}
                        />
                      </div>
                      <div className="text-2xl">{radioButton.title}</div>
                    </div>
                  </label>
                </div>
              ))}
          </div>
        </div>
        <Dialog
          isOpen={Boolean(createPortfolio)}
          onClose={() => setCreatePortfolio(undefined)}
          modalClass="rounded-md p-6 w-96 max-h-full h-auto"
        >
          <div className="">
            <div className="flex gap-2 justify-between items-center mb-2">
              <h2 className="text-gray-800">
                {createPortfolio == "portfolio"
                  ? t("Create Portfolio")
                  : t("Create Program")}
              </h2>
              <div>
                <img
                  src={CrossIcon}
                  className="w-3 min-w-3 cursor-pointer"
                  onClick={() => {
                    setCreatePortfolio(undefined);
                  }}
                />
              </div>
            </div>
            {createPortfolio == "portfolio" && (
              <div>
                <label className={labelStyle + " !mt-2"}>
                  {t("Portfolio")}
                </label>
                <InputText
                  onChange={createPortfolioAndProgramFormik.handleChange}
                  onBlur={createPortfolioAndProgramFormik.handleBlur}
                  name="portfolio"
                  className="mt-0"
                />
                {createPortfolioAndProgramFormik.touched.portfolio &&
                  createPortfolioAndProgramFormik.errors.portfolio && (
                    <ErrorMessage>
                      {createPortfolioAndProgramFormik.errors.portfolio}
                    </ErrorMessage>
                  )}
              </div>
            )}
            {createPortfolio == "program" && (
              <div>
                <div>
                  <div className="flex gap-2 justify-between items-center">
                    <label className={labelStyle}>{t("Portfolio")}</label>
                  </div>
                  <Select
                    key={createPortfolioAndProgramFormik.values.portfolio}
                    className="mt-2"
                    placeholder="Select Portfolio"
                    options={portfolios}
                    isDisabled={Boolean(formik.values.portfolio)}
                    value={portfolios.find((option) => {
                      const portfolio =
                        allPortfoliosQuery.data?.data.data.portfolios.find(
                          (t) =>
                            t.portfolioName ==
                            createPortfolioAndProgramFormik.values.portfolio
                        );
                      if (option.value == portfolio?.portfolioId) {
                        return option;
                      }
                    })}
                    styles={{
                      ...reactSelectStyleWorkingDays,
                    }}
                    onChange={(e) => {
                      const val = e as Options;
                      if (val && val.value) {
                        const findPort = allPortfolios?.portfolios.find(
                          (e) => e.portfolioId == val.value
                        );
                        createPortfolioAndProgramFormik.setFieldValue(
                          "portfolio",
                          findPort?.portfolioName
                        );
                      } else {
                        createPortfolioAndProgramFormik.setFieldValue(
                          "portfolio",
                          ""
                        );
                      }
                    }}
                  ></Select>
                </div>
                <div>
                  <label className={labelStyle + " !mt-2"}>
                    {t("Program")}
                  </label>
                  <InputText
                    onChange={createPortfolioAndProgramFormik.handleChange}
                    onBlur={createPortfolioAndProgramFormik.handleBlur}
                    name="program"
                    className="mt-0 z-50"
                  />
                  {createPortfolioAndProgramFormik.touched.program &&
                    createPortfolioAndProgramFormik.errors.program && (
                      <ErrorMessage>
                        {createPortfolioAndProgramFormik.errors.program}
                      </ErrorMessage>
                    )}
                </div>
              </div>
            )}
            <div className="flex gap-2 items-center justify-end w-full mt-2">
              <Button
                type="button"
                variant={"destructive"}
                onClick={() => {
                  setCreatePortfolio(undefined);
                }}
                isLoading={createPortfolioProgramMutation.isPending}
              >
                {t("cancel")}
              </Button>
              <Button
                type="button"
                variant={"primary"}
                onClick={() => {
                  createPortfolioAndProgramFormik.submitForm();
                }}
                isLoading={createPortfolioProgramMutation.isPending}
              >
                {t("submit")}
              </Button>
            </div>
          </div>
        </Dialog>
        <Dialog
          isOpen={Boolean(
            deletePortfolioAndProgram?.portfolio ||
              deletePortfolioAndProgram?.program
          )}
          onClose={() => {}}
          modalClass="rounded-lg"
        >
          <div className="flex flex-col gap-2 p-6 text-center ">
            <img src={TrashCan} className="w-12 m-auto" />{" "}
            {deletePortfolioAndProgram?.portfolio
              ? t("remove_portfolio")
              : t("remove_program")}
            <span className="text-xs text-gray-600">
              (
              {t("remove_portfolio_and_project_description", {
                project: deletePortfolioAndProgram?.portfolio
                  ? `${t("program")} ${t("and")} ${t("project")}`
                  : `${t("project")}`,
              })}
              )
            </span>
            <div className="flex gap-2 ml-auto">
              <Button
                variant={"outline"}
                onClick={() => setDeletePortfolioAndProgram(undefined)}
              >
                {t("cancel")}
              </Button>
              <Button
                variant={"primary"}
                // isLoading={removeTaskMutation.isPending}
                // disabled={removeTaskMutation.isPending}
                onClick={handleRemovePortfolioAndProgram}
              >
                {t("delete")}
              </Button>
            </div>
          </div>
        </Dialog>
        <Dialog
          isOpen={Boolean(blocker.state === "blocked")}
          onClose={() => {
            // blocker.reset();
          }}
          modalClass="rounded-lg w-3/12 text-center"
        >
          <div className="flex flex-col gap-2 p-6 ">
            <LucideAlertTriangle className="w-12 m-auto" />{" "}
            {t("route_block_message")}
            <div className="flex gap-2 ml-auto">
              <Button
                variant={"primary"}
                onClick={() => {
                  blocker.reset && blocker.reset();
                }}
              >
                {t("ok")}
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
);
